import React from 'react';
import { ConfigProvider, TimePicker, TimePickerProps } from 'antd';
import { Colors } from 'basic-ui-lib/constants';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
dayjs.locale('en');


const BaseTimePicker = (props: TimePickerProps) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          controlHeight: 48,
          borderRadius: 5,
        },
        components: {
          DatePicker: {
            fontSize: 16,
            fontFamily: 'Poppins, sans-serif',
            fontWeightStrong: 500,
            colorText: Colors.neutral.text[5],
            activeBorderColor: Colors.primary[6],
            hoverBorderColor: Colors.primary[6],
          },
        },
      }}
    >
      <TimePicker {...props} style={{ width: '100%' }} format="HH:mm:ss" />
    </ConfigProvider>
  );
};

export default BaseTimePicker;
